import { useEffect, useState } from "react";
import { useDowloadSettingMutation } from "../../store/storageRoles/devicesSharedApi";

const useDeviceSettingData = () => {
  const [data, setDeviceSettingData] = useState(null);

  const [
    getDeviceSetting,
    {
      data: deviceSettingData,
      isLoading: deviceSettingIsLoading,
      isError: deviceSettingIsError,
      isSuccess: deviceSettingIsSuccess,
      status: deviceSettingStatus,
      error: deviceSettingError,
    },
  ] = useDowloadSettingMutation();

  useEffect(() => {
    if (deviceSettingData?.data?.settings) {
      setDeviceSettingData(deviceSettingData?.data?.settings);
    }
  }, [deviceSettingData]);

  const settingsReadOnly = Boolean(deviceSettingData?.data?.readOnly);

  return {
    getDeviceSetting,
    deviceSettings: data,
    deviceSettingIsLoading,
    deviceSettingStatus,
    deviceSettingError,
    deviceSettingIsSuccess,
    setDeviceSettingData,
    settingsReadOnly,
  };
};

export default useDeviceSettingData;
